import {graphql} from 'react-relay'

export const licensingDataQuery = graphql`
  query AuthorizeAgentLicensingDataQuery {
    licensingData {
      agentsLeft
    }
  }
`
